const underscoreReplacer = (s: string) => {
    const transformed = s.replace(/_/g, " ");
    return transformed;
};

export default underscoreReplacer;
